import styled from "styled-components";

import { Flex } from "../../shared/components";

export const EventPageContent = styled(Flex)`
  padding: ${props => `${props.theme.space[2]} ${props.theme.space[1]}`}
  width: 75%;
`;
